// src/components/customers/AddressCard.jsx
import React from 'react';

export default function AddressCard({ address, compact=false }) {
  if (!address) return null;
  const L = (v) => (v ? String(v) : '-');

  return (
    <div className="card mb-2">
      <div className="card-body py-2">
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <div className="fw-semibold">{L(address.street)}</div>
            <div className="text-muted small">
              {L(address.subdistrict)}, {L(address.district)}, {L(address.city)}
            </div>
            <div className="text-muted small">
              {L(address.province)}
            </div>
          </div>
          {!compact && address.updated_at && (
            <div className="text-muted small">Updated {new Date(address.updated_at).toLocaleString()}</div>
          )}
        </div>
      </div>
    </div>
  );
}
